import React from "react";

// Reusable page-header for inner pages with Marathi/English title
const PageHeader = ({ eyebrow, title, subtitle, testId = "page-header" }) => (
  <section data-testid={testId} className="pt-32 pb-12 md:pt-36 md:pb-16 bg-gradient-to-b from-[#F0F0EA] to-school-bg relative overflow-hidden">
    <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
      style={{ backgroundImage: "radial-gradient(circle at 1px 1px, #1E4E8C 1px, transparent 0)", backgroundSize: "24px 24px" }} />
    <div className="container-school relative">
      {eyebrow && <span className="eyebrow block mb-3 animate-fade-up">{eyebrow}</span>}
      <h1 className="font-heading font-extrabold text-4xl md:text-5xl lg:text-6xl text-school-primary animate-fade-up delay-100 leading-tight">
        {title}
      </h1>
      {subtitle && (
        <p className="mt-4 max-w-3xl text-base md:text-lg text-school-muted animate-fade-up delay-200 leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  </section>
);

export default PageHeader;
